<template>
  <div>
    <b-container fluid>


      <div class="row ">
        <DashboardMobile :items="menuItems"></DashboardMobile>
        <DashboardDesktop :items="menuItems"></DashboardDesktop>

        <div class="col-lg-10  d-lg-block ">
          <slot></slot>
        </div>

      </div>

    </b-container>
  </div>
</template>

<script>
import DashboardMobile from "./DashboardMenu/mobile";
import DashboardDesktop from "./DashboardMenu/desktop";

export default {
  name: "Layout",
  components: {DashboardMobile, DashboardDesktop},
  props: ['menuItems']
}
</script>

<style scoped>

</style>